export default __webpack_public_path__ + "resources/icons/d441-18a0.png";